import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Lightbox } from 'ngx-lightbox';
import { Observable, of } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { MidjourneyUserDetail, MidjourneyUserDetailResponse, Users } from 'src/app/models/users.model';
import { UserUsedPakageComponent } from 'src/app/payment/user-pakages/user-used-pakage/user-used-pakage.component';
import { UsersService } from 'src/app/services/users.service';
import { SeoService } from 'src/app/services/seo.service';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { environment } from 'src/environments/environment.prod';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-gallery-page',
    templateUrl: './gallery-page.component.html',
    styleUrls: ['./gallery-page.component.scss'],
    standalone: false
})
export class GalleryPageComponent implements OnInit {
    constructor(private router: Router, public _lightbox: Lightbox, public usersService: UsersService,  
        public authenticationService: AuthenticationService,private modalService: NgbModal,
        private seoService: SeoService
    ) {

    }
    showSections = false;
    currentPage = 1;
    itemsPerPage = 9; // Set this based on your actual items per page count
    totalItems: any; // Set this based on your actual total items count
    user: Users;
    userDetail: any;

    totalPages: any;

    private pageSize = 10;
    public response: any[] = [];
    midjourneyUserDetail: MidjourneyUserDetailResponse = new MidjourneyUserDetailResponse();
    ngOnInit(): void {
        // Update SEO for Gallery page
        this.seoService.updateSEO({
            title: 'Photo Gallery | Lama Driving School Staten Island',
            description: 'Browse photos of our driving lessons, instructors, and facilities at Lama Driving School in Staten Island, NY. See our students in action.',
            keywords: 'driving school photos, Staten Island driving lessons, driving instructor photos, driving school gallery',
            canonical: 'https://lamadrivingschool.com/gallery'
        });

        this.fetchData();
        this.authenticationService.getUserDetailToShow$().subscribe(x => {
            this.userDetail = x
        });
    }
    createImgPath = (serverPath: string) => {
        if (serverPath)
            return `${environment.patchUrl}/${serverPath}`;
    }
    getVisiblePageNumbers(): number[] {
        const visiblePages: number[] = [];
        const startPage = Math.max(this.currentPage - 2, 1);
        const endPage = Math.min(startPage + 4, this.totalPages);

        for (let page = startPage; page <= endPage; page++) {
            visiblePages.push(page);
        }

        return visiblePages;
    }
    fetchData() {
        const requestData = {
            paginator: {
                page: this.currentPage,
                pageSize: this.pageSize,
                total: 0,
                pageSizes: []
            },
            searchTerm: '',
            langId: 2,
            isArchived: false
        };
    
    }
    public _album = [];


    open(index: number): void {
        this._lightbox.open(this._album, index);
    }

    close(): void {
        // close lightbox programmatically
        this._lightbox.close();
    }
    downloadImage(index: number) {
        const imageUrl = this._album[index].thumb;
        const link = document.createElement('a');
        link.href = imageUrl;
        link.download = `image_${index + 1}.jpg`;
        link.target = '_blank'; // Open the link in a new tab
        link.click();
    }
    content$: Observable<string>;

    isSaving: boolean;
    loading: boolean;
   

    getPageNumbers(): number[] {
        const totalPages = Math.ceil(this.response.length / this.pageSize);
        return Array.from({ length: totalPages }, (_, index) => index + 1);
    }
    onPageChange(page: number): void {
        if (page >= 1 && page <= this.totalPages) {
            this.currentPage = page;
            this.fetchData();
        }
    }

    previousPage(): void {
        if (this.currentPage > 1) {
            this.currentPage--;
            this.fetchData();
        }
    }
    userUserPakage() {
        const modalRef = this.modalService.open(UserUsedPakageComponent, { size: 'md' });
        modalRef.result.then(() =>
          () => { }
        );
      }

    nextPage(): void {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
            this.fetchData();
        }
    }

    print(image: string) {
        this.router.navigate(['/payment/products'], { queryParams: { image } });
    }

    archivedImage(referenceId: string) {
     

    }
  
}